/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.7.5
@license MIT
@copyright (c) 2017, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _constant = _interopDefault(require('lodash/fp/constant'));
var __ol = _interopDefault(require('openlayers'));
var core = require('../core');

var LineString = __ol.geom.LineString;
var props = {};

var computed = {
  type: _constant(core.GEOMETRY_TYPE.LINE_STRING)
};

var methods = {
  /**
   * @returns {ol.geom.LineString}
   * @protected
   */
  createGeometry: function createGeometry() {
    return new LineString(this.fromLonLat(this.coordinates));
  }
};

var Geom = {
  name: 'vl-geom-line-string',
  mixins: [core.geometry],
  props: props,
  computed: computed,
  methods: methods
};

var index = {
  Geom: Geom,
  install: function install(Vue) {
    Vue.component(Geom.name, Geom);
  }
};

module.exports = index;

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/line-string-geom/index.js
// module id = 1184
// module chunks = 1